export default {
    "messages": {
        "no-data": "Derzeit liegen keine Daten vor",
        "latina": {
            "player": {
                "share": "[not used](DE) Partilhar",
                "share-message": "[not used](DE) Estou a ouvir {song}-{artist} na Rádio Latina",
                "no-track-info": "[not used](DE) Sem informação da música",
                "no-artist": "[not used](DE) Sem artista",
                "last-tracks": {
                    "title": "[not used](DE) Últimas Músicas"
                }
            }
        },
        "service": {
            "traffic":{
                "alert": {
                    "title": "Verkehrsinfos",
                    "none": "Keine Verkehrsmeldungen"
                },
                "trafficcamera": {
                    "title": "Web Cam"
                },
                "parking": {
                    "title": "Parkplätze",
                    "defaultDistrict": "Zentrum",
                    "column": {
                        "carParks": "Parkhaus",
                        "capacity": "Kapazität",
                        "occupied": "Belegung",
                        "free": "Frei",
                        "trend": "Tendenz"
                    },
                    "closed": "geschlossen"
                },
                "no-data": "keine Daten"
            },
            "sport-results": {
                "sport-name": {
                    "footballNational": "Fussball national",
                    "footballInternational": "Fussball international",
                    "basketball": "Basketball",
                    "handball": "Handball",
                    "volleyball": "Volleyball",
                    "tableTennis": "Tischtennis"
                },
                "title": {
                    "prefix": "Ergebnisse für den",
                    "day": ".",
                    "suffix": "Spieltag",
                    "mobile-prefix": "Ergebnisse",
                    "mobile-suffix": "Spieltag"
                },
                "ranking": {
                    "title": "Tabelle nach dem aktuellen Spieltag",
                    "mobile-title": "Tabelle (aktueller Spieltag)",
                    "position": "Pos.",
                    "team": "Team",
                    "played": "Gesp.",
                    "won": "Ge.",
                    "draw":"G.",
                    "lost": "V.",
                    "difference": "Dif.",
                    "points": "Pkt."
                }
            },
            "commons": {
                "luxembourgCitySouth": "Lux. Stadt (Süd)",
                "germanyBorder": "Deutschland",
                "franceBorder": "Frankreich",
                "luxembourgCityHollerich": "Luxemburg Hollerich",
                "eschSurAlzette": "Esch-sur-Alzette",
                "belgiumBorder": "Belgien",
                "grunewald": "Grunewald",
                "colmarBerg": "Colmar-Berg",
                "sarrebruck": "Saarbrücken",
                "longwy": "Longwy",
                "no-data": "Derzeit liegen keine Daten vor"
            },
            "events": {
                "countries": {
                    "lu": "Luxemburg",
                    "de": "Deutschland",
                    "fr": "Frankreich",
                    "be": "Belgien",
                    "none": ""
                },
                "upcoming": "Vorschau",
                "permanents": "Dauerhafte Veranstaltungen",
                "timeFromFormat": "von",
                "timeToFormat": "bis",
                "dateStartFormat": "[Von] ll",
                "dateStartingFromFormat": "[Von der] ll",
                "dateEndFormat": " [bis] ll",
                "allEvents": "Alle Veranstaltungen",
                "no-events": "Keine Veranstaltungen geplant",
                "categories": {
                    "all": "Alle",
                    "concerts": "Musik",
                    "nightlife": "Nachtleben",
                    "dance": "Tanz",
                    "opera_theatre": "Oper & Theater",
                    "sport": "Sport",
                    "spectacle": "Aufführungen",
                    "festivity_festival": "Feste",
                    "conference_seminar": "Bildung",
                    "exhibition": "Ausstellungen",
                    "family_kids": "Familie",
                    "other": "Weiteres"
                },
                "event-details": {
                    "show-more-dates": "Mehr Termine anzeigen",
                    "show-map": "Karte anzeigen",
                    "free": "Eintritt frei",
                    "fallback-description": "Es gibt keine Beschreibung ist in Ihrer Sprache",
                    "no-description": "Es gibt keine Beschreibung",
                    "canceled": "abgesagt",
                    "monday": "Montag",
                    "tuesday": "Dienstag",
                    "wednesday": "Mittwoch",
                    "thursday": "Donnerstag",
                    "friday": "Freitag",
                    "saturday": "Samstag",
                    "sunday": "Sonntag",
                    "closed": "geschlossen"
                }
            }
        },
        "commons": {
            "delete": "Löschen",
            "show-more": "Mehr"
        },
        "share-buttons": {
            "copy-to-clipboard-message": "Der Link wurde in die Zwischenablage kopiert"
        },
        "homepage": {
            "new-articles": "Neue Beiträge laden"
        },
        "notifications-page": {
            "subscription": {
                "success": {
                    "subscribe": "Sie haben unsere Benachrichtigungen erfolgreich abonniert.",
                    "unsubscribe": "Sie haben sich erfolgreich abgemeldet."

                },
                "fail": "Entschuldigung, wir konnten Sie nicht für unseren Service anmelden. Bitte schauen Sie in unsere FAQ."
            },
            "permission": {
                "blocked": "Sie können unsere Benachrichtigungen nicht erhalten, weil Sie sie blockiert haben. Bitte ändern Sie Ihre Browsereinstellungen, um Benachrichtigungen zuzulassen."
            },
            "unsupported-browser": "Ihr Browser unterstützt leider unsere Benachrichtigungen nicht."
        },
        "services": {
            "announcements": {
                "births": "Geburten",
                "weddings": "Hochzeiten",
                "obituaries": "Todesanzeigen"
            }
        },
    }
};



// WEBPACK FOOTER //
// ./js/i18n/TranslationGerman.js